var _defs, _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRuntime = function SvgRuntime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Runtime_svg__f73afc21-cdbf-4fb0-ad36-b223ec9a7393{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Runtime_svg__a0d523f3-fec1-4c22-82a4-04a9431ad2d6",
    "data-name": "Runtime"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h250v250H0z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Runtime_svg__f73afc21-cdbf-4fb0-ad36-b223ec9a7393",
    cx: 125,
    cy: 125,
    r: 56.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Runtime_svg__f73afc21-cdbf-4fb0-ad36-b223ec9a7393",
    d: "M125 85.75v42.42l18.53 18.53"
  }))));
};

export default SvgRuntime;